import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[2]};
`;

export const Tile = styled.button<{ $open: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  flex: 1 1 11.875rem;
  min-width: 0;
  min-height: 3.5rem;
  padding: ${spacing[2]} ${spacing[3]} ${spacing[2]} ${spacing[2]};
  border: 1px solid ${({ theme, $open }) => ($open ? theme.colors.primary[500] : theme.colors.border.stroke)};
  border-radius: ${borderRadius.lg};
  background: ${({ theme, $open }) => ($open ? theme.colors.primary[100] : theme.colors.surface.primary)};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary[200]};
    background: ${({ theme, $open }) => ($open ? theme.colors.primary[100] : theme.colors.surface.secondary)};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }
`;

export const IconBox = styled.span`
  display: grid;
  place-items: center;
  flex: none;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: ${borderRadius.lg};
  background: ${({ theme }) => theme.colors.primary[100]};
  color: ${({ theme }) => theme.colors.primary[500]};

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const Text = styled.span`
  display: grid;
  min-width: 0;
`;

export const Title = styled.span`
  ${typographyMixin("body", 2)}
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Description = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow-wrap: anywhere;
`;

export const Chevron = styled.span`
  display: inline-flex;
  margin-left: auto;
  color: ${({ theme }) => theme.colors.text.secondary};

  svg {
    width: 1rem;
    height: 1rem;
  }
`;
